import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Toolbar, Typography } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import blockProps from '../../../utils/blockProps';
import SearchBar from '../../SearchBar';

const EnhancedTableToolbar = ({
  tableTitle,
  tableSubtitle,
  tableData,
  rowsNumber,
  numSelected,
  renderToolbars,
  onSearch,
  disableSearchBar,
}) => (
  <StyledToolbar highlight={numSelected > 0}>
    <div>
      {numSelected > 0 ? (
        <Typography color="inherit" variant="subheading">
          {`${numSelected} selected`}
        </Typography>
      ) : (
        <div>
          <Typography variant="title" id="tableTitle">
            {tableTitle}
          </Typography>
          <Typography variant="subheading">{`${tableSubtitle}:  ${rowsNumber}`}</Typography>
        </div>
      )}
    </div>

    <Spacer />

    <ToolbarContainer>
      {!disableSearchBar && (
        <SearchBar
          data={tableData}
          onChange={(searchedData) => {
            onSearch(searchedData);
          }}
        />
      )}

      {renderToolbars()}
    </ToolbarContainer>
  </StyledToolbar>
);

EnhancedTableToolbar.propTypes = {
  tableTitle: PropTypes.string,
  tableSubtitle: PropTypes.string,
  tableData: PropTypes.arrayOf(PropTypes.object),
  rowsNumber: PropTypes.number.isRequired,
  numSelected: PropTypes.number,
  renderToolbars: PropTypes.func,
  onSearch: PropTypes.func,
  disableSearchBar: PropTypes.bool,
};

EnhancedTableToolbar.defaultProps = {
  tableTitle: '',
  tableSubtitle: 'Total',
  tableData: [],
  numSelected: 0,
  renderToolbars: () => {},
  onSearch: () => {},
  disableSearchBar: false,
};

export default EnhancedTableToolbar;

const StyledToolbar = styled(blockProps(Toolbar, ['highlight']))`
  ${props => props.highlight
    && css`
      background-color: ${lighten(props.theme.palette.secondary.light, 0.85)};
      color: ${props.theme.palette.secondary.main};
    `};
`;

const Spacer = styled.div`
  flex: 1;
`;

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 10px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataTable/components/EnhancedTableToolbar.js